import { NgModule } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { configureUserPool } from '@callrail/looky/anubis/login/shared';
import { AppModule } from './app/app.module';

configureUserPool()
  .then(() => platformBrowser().bootstrapModule<NgModule>(AppModule))
  // eslint-disable-next-line no-console
  .catch(console.error);
